import api from '@/utils/api';
import { getToken } from '@/utils/token';
import { menu, routers, authMenu, authRoutes } from '@/utils/config';
export default {
    namespace: true,
    state: {
        list: [],
        whiteAuth: ['/login'],
        // menuAuth: authMenu,
        menuList: authRoutes,
        routers: routers,
        menuAll: menu,
        authRoutes: authRoutes,
        agentFlag: false,
        roles: [],
        agentParams: {},
        isQuery: true,
        darkMode: getToken() ? (localStorage.getItem('DARK_MODE') ? localStorage.getItem('DARK_MODE') : 'light') : 'light',
        permissionList: []
    },
    mutations: {
        increment(state, payload) {
            //在这里改变state中的数据
            // state.count = payload.number;
            state.list = payload.list;
        },
        setMenu(state, payload) {
            state.menuList = payload.menuList;
        },

        SET_IS_QUERY(state, isQuery) {
            state.isQuery = isQuery;
        },

        SET_PERMISSION_LIST(state, permissionList) {
            state.permissionList = permissionList;
        },

        SET_AGENT_FLAG(state, agentFlag) {
            state.agentFlag = agentFlag;
        },
        SET_AGENT_PARAMS(state, agentParams) {
            state.agentParams = agentParams;
        },
        SET_DARK_MODE(state, darkMode) {
            state.darkMode = darkMode;
        }
    },
    actions: {
        reloadMenu({ commit }, menuList) {
            //请求后台数据
            commit('setMenu', { menuList });
        },
        SET_DARK_MODE({ commit }, payload) {
            commit('SET_DARK_MODE', payload);
            localStorage.setItem('DARK_MODE', payload);
        },
        SET_AGENT_FLAG({ commit }, payload) {
            commit('SET_AGENT_FLAG', payload);
        },
        SET_AGENT_PARAMS({ commit }, payload) {
            commit('SET_AGENT_PARAMS', payload);
        },

        async searchUser({ commit }, id) {
            let result = await api.get(`/users/detail?id=${id}`);
            return result;
        },

        setPermission({ commit }, payload) {
            commit('SET_PERMISSION_LIST', payload);
        },

        CheckQuery: async ({ commit, rootGetters }, permission) => {
            commit('SET_IS_QUERY', rootGetters.permissions.indexOf(permission) != -1);
        }
    }
};
